import {formBuilder} from '@zoefin/form-builder';

import {
  AdditionalProps,
  FormFields,
  FormStructure,
} from '../../commons/FormsLibrary/types';

export const {
  Form,
  useFormContext,
  stepFactoryHOC,
  structureFactory,
  layoutFactory,
  validatorsFactory,
  navigationControllersFactory,
  handleNextFactory,
  onSubmitFactory,
} = formBuilder<FormFields, FormStructure, AdditionalProps>();
